import http from "../../../core/services/http.service";
import bucketHelperService from "@/core/services/bucketHelper.service";

export default {
  getTemporaryItems(params = null) {
    return http.get('/api/v1/inventories/temporary/', {params});
  },
  getTemporaryItem(id, expand) {
    return http.get(`/api/v1/inventories/temporary/${id}/?expand=${expand}`);
  },
  updateTemporaryItem(id, data, expand, onUploadProgress) {
    const payload = {...data, base64_upload_mode: false}
    return http.put(`/api/v1/inventories/temporary/${id}/?expand=${expand}`, payload, {
      onUploadProgress: onUploadProgress
    });
  },
  createTemporaryItem(data, expand) {
    const payload = {...data, base64_upload_mode: false}
    return http.post(`/api/v1/inventories/temporary/?expand=${expand}`, payload);
  },
  moveArchived(data) {
    return http.post('/api/v1/inventories/temporary/move-archived/', data);
  },
  approveItems(data) {
    return http.post('/api/v1/inventories/temporary/create-inventory/?expand=miscellaneous_items', data);
  },
  getImages(temporaryInventoryUuid) {
    const payload = {
      params: {
        temporary_inventory_uuid: temporaryInventoryUuid,
      }
    }
    return http.get('/api/v1/inventories/temporary-images/', payload)
  },
  createRenameAndDeleteImages(temporaryInventoryUuid, images, url, progressEvent) {
    const jsonData = {'temporary_inventory_uuid': temporaryInventoryUuid}
    return bucketHelperService.createRenameAndDeleteImages(images, url, 'temporary_inventory', jsonData, progressEvent)
  }
};
